import { useState } from 'react';
import Section, { SectionHeading } from '@/components/Section';
import Reveal from '@/components/Reveal';
import Gallery, { GalleryFilters } from '@/components/Gallery';
import { PROJECTS } from '@/data/portfolio';

function ProjectCard({ project, index }) {
  return (
    <Reveal delay={(index % 2) * 0.08} className={`${project.span} flex`}>
      <figure data-testid={`project-${project.id}`} className="group flex w-full flex-col">
        <div className={`${project.ratio} overflow-hidden bg-white/5`}>
          <img
            src={project.image}
            alt={project.alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
        </div>
        <figcaption className="mt-4">
          <span className="eyebrow text-white/60">{project.category}</span>
          <p className="mt-2 text-xl font-semibold leading-snug">{project.title}</p>
          <p className="mt-1 text-white/70">{project.description}</p>
        </figcaption>
      </figure>
    </Reveal>
  );
}

export default function Portfolio() {
  const [filter, setFilter] = useState('all');
  return (
    <Section id="portfolio" tone="dark">
      <SectionHeading
        tone="dark"
        eyebrow="Portfolio"
        title="Naši radovi"
        text="Izbor iz naših realizovanih projekata."
      />
      <GalleryFilters filter={filter} onChange={setFilter} className="mt-10" />
      {filter === 'all' && (
        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-12 lg:grid-cols-12">
          {PROJECTS.map((project, i) => (
            <ProjectCard key={project.id} project={project} index={i} />
          ))}
        </div>
      )}
      <Gallery key={filter} filter={filter} featuredShown={filter === 'all'} className={filter === 'all' ? 'mt-16' : 'mt-10'} />
    </Section>
  );
}
